import React, { useState } from 'react';
import { Formik, Form, FormikHelpers as FormikActions, FormikErrors, FormikValues } from 'formik';

import { FormGroupBootstrap, ErrorBlockGeneric } from '../common-components'
import {
  Country, Region,
} from '../api/types';
import { get_cached_item_from_cache, handle_drf_form_error } from 'django-rest-react';
import { TIPOLOGIE_SCUOLA, displayScuola } from '../globals'
import { post_new_person } from '../api'
import store from '../store'
import { add_toast_action } from '../actions'
import { useCountry, useRegione } from '../reducers/cache';

type NuovaPersonaFormData = Parameters<typeof post_new_person>[0];

interface FormValues {
  // [key: string]: string | number | boolean,
  nome: string,
  cognome: string,
  email: string,
  cellulare: string,
  data_nascita: string,
  scuola_tipologia: string,
  scuola_regione: number,
  scuola: number,
  paese_nascita: number,
  nascita_regione?: number,
  nascita_city?: number,
  residenza_regione: number,
  residenza_citta: number,
  residenza_indirizzo: string,
}

const displayGeneric = (r: Region | Country) => r.name

type Intersection = Extract<keyof NuovaPersonaFormData, keyof FormValues>;

const NuovaPersonaForm = (props: {}) => {
  const [error, setError] = useState(null);

  const countries = useCountry(props);
  const regioni = useRegione(props);

  const initial: FormValues = {
    nome: '', cognome: '', email: '', cellulare: '', data_nascita: '', scuola_tipologia: '',
    scuola_regione: null, scuola: null, paese_nascita: null, nascita_regione: null, nascita_city: null,
    residenza_regione: null, residenza_citta: null, residenza_indirizzo: '',
  }
  return (
    <div>
      <ErrorBlockGeneric
        error={error}
      />
      <Formik
        initialValues={initial}
        onSubmit={(values: FormValues, actions: FormikActions<FormValues>) => {
          const FIELDS: Intersection[] = ["nome", "cognome", "email", "cellulare", "data_nascita", "scuola", "paese_nascita"];
          let submitting_data: NuovaPersonaFormData = {} as unknown as NuovaPersonaFormData;
          for (const v of FIELDS) {
            // @ts-ignore
            submitting_data[v] = values[v];
          }
          const italy = countries.find(coun => coun.name == "Italia");
          if (values.paese_nascita == italy.id) {
            submitting_data.luogo_nascita = values.nascita_city;
          }

          submitting_data.indirizzo = {
            nome: values.residenza_indirizzo,
            citta: values.residenza_citta,
          };
          post_new_person(submitting_data)
            .then(() => store.dispatch(add_toast_action({
              title: "Persona aggiunta",
              message: `La persona ${values.nome} ${values.cognome} è stata aggiunta con successo.`
            })))
            .catch(error => handle_drf_form_error(error, actions, setError))
            .finally(() => actions.setSubmitting(false))
        }}
        enableReinitialize={true}
      >
        {({ isSubmitting, values }) => {
          const italia = countries.find(coun => coun.name == "Italia");
          let scuola_select; let residenza_select; let nascita_select;
          if (values.scuola_tipologia != '' && values.scuola_regione) {
            let scuole = get_cached_item_from_cache(
              "scuola", [{ name: "tipologia", value: values.scuola_tipologia },
              { name: "region", value: values.scuola_regione.toString() }]);
            if (!scuole) { scuole = []; }

            scuola_select =
              <FormGroupBootstrap
                type="select" name="scuola" choices={scuole}
                displayChoice={displayScuola}
                help_text="Se la scuola non è presente nell'elenco, si provi sotto le altre tipologie, in particolare se la scuola ha più indirizzi. Nel caso in cui non sia presente sotto nessuna tipologie, segnalacelo per email. La lista è stata presa dal sito del MIUR."
                search={true}
              />
          }
          if (values.residenza_regione) {
            let citta = get_cached_item_from_cache("cities", [{ name: "region", value: values.residenza_regione.toString() }]);
            if (!citta) { citta = []; }
            residenza_select =
              <FormGroupBootstrap
                type="select" name="residenza_citta" choices={citta}
                displayChoice={displayGeneric}
                displayName="Città di residenza"
                search={true}
              />
          }
          if (values.nascita_regione) {
            let citta = get_cached_item_from_cache("cities", [{ name: "region", value: values.nascita_regione.toString() }]);
            if (!citta) { citta = []; }
            nascita_select =
              <FormGroupBootstrap
                type="select" name="nascita_city" choices={citta}
                displayChoice={displayGeneric}
                displayName="Città di nascita"
                search={true}
              />

          }

          return (
            <Form className="form needs-validation">
              <FormGroupBootstrap name="nome" type="text" />
              <FormGroupBootstrap name="cognome" type="text" />
              <FormGroupBootstrap name="email" type="email" help_text="È importante che la mail sia valida, verranno inviate conferme e informazioni a questo indirizzo" />
              <FormGroupBootstrap name="cellulare" type="text" help_text="Un numero di cellulare valido dello studente per essere contattato in caso di emergenza durante lo stage. Deve essere preceduto dal prefisso internazionale senza spazi. Per esempio un numero valido è +390123456789"
              />

              <FormGroupBootstrap
                name="data_nascita"
                displayName="Data di nascita"
                type="text"
                placeholder="YYYY-MM-DD"
              />

              <div className="card px-2 py-2 mb-2">
                <FormGroupBootstrap
                  name="scuola_tipologia"
                  type="select"
                  choices={TIPOLOGIE_SCUOLA}
                />
                <FormGroupBootstrap
                  name="scuola_regione"
                  type="select"
                  choices={regioni}
                  displayChoice={displayGeneric}
                />
                {scuola_select}
              </div>
              <div className="card px-2 py-2 mb-2">
                <FormGroupBootstrap
                  name="paese_nascita"
                  displayName="Paese di nascita"
                  type="select"
                  displayChoice={displayGeneric}
                  choices={countries}
                  search={true}
                />
                {italia && values.paese_nascita == italia.id &&
                  <>
                    <FormGroupBootstrap
                      name="nascita_regione"
                      type="select"
                      displayName="Regione di nascita"
                      choices={regioni}
                      displayChoice={displayGeneric}
                    />
                    {nascita_select}
                  </>
                }
              </div>
              <div className="card px-2 py-2 mb-2">
                <FormGroupBootstrap
                  name="residenza_regione"
                  type="select"
                  displayName="Regione di residenza"
                  choices={regioni}
                  displayChoice={displayGeneric}
                />
                {residenza_select}
                <FormGroupBootstrap
                  name="residenza_indirizzo"
                  type="text"
                  displayName="Indirizzo di residenza"
                />
              </div>
              <div className="d-flex justify-content-end">
                <button className="btn btn-success" type="submit" disabled={isSubmitting}>Invia</button>
              </div>
            </Form>
          );
        }
        }
      </Formik>
    </div>
  )
}

export default NuovaPersonaForm;
